import { useLayoutEffect as LayoutEffect, useEffect } from "react";
export const useLayoutEffect =
  typeof window !== "undefined" ? LayoutEffect : useEffect;
